import { create } from 'zustand';
import type { ExplanationTopic } from '@/config/fieldExplanations';

interface InfoPanelState {
  isOpen: boolean;
  topicKey: ExplanationTopic | null;
}

interface InfoPanelActions {
  open: (key: ExplanationTopic) => void;
  close: () => void;
}

export const useInfoPanelStore = create<InfoPanelState & InfoPanelActions>((set) => ({
  isOpen: false,
  topicKey: null,
  open: (key) => set({ isOpen: true, topicKey: key }),
  close: () => set({ isOpen: false }),
}));
